import React from "react";
import Section1 from "../components/Technology/Section1";
import Section2 from "../components/Technology/Section2";

const Technology = () => {
  return (
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px]  ruler">
      <Section1 />
      <Section2 />
    </div>
  );
};

export default Technology;
